import { Box } from "@mui/material";
interface IMosaicPreviewPanelProps {
  x: number;
  y: number;
  width: number;
  height: number;
}

/**
 * Component that renders a ghosted panel to show users what space a mosaic window will occupy before being dropped.
 * @param props - position and size props
 * @returns
 */
export const MosaicPreviewPanel = (props: IMosaicPreviewPanelProps): JSX.Element => {
  const { x, y, width, height } = props;
  return (
    <Box
      sx={(theme) => ({
        position: "absolute",
        zIndex: 1337,
        backgroundColor: theme.palette.primary.light,
        opacity: 0.5,
        left: x ?? 0,
        top: y ?? 0,
        width: width ?? 0,
        height: height ?? 0,
      })}
    />
  );
};
